import { createContext, useContext, useState } from "react";
// create the context
const AppContext = createContext();

// create the provider
export const AppProvider = ({ children }) => {
	const [isToggle, setIsToggle] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const togglerHandler = () => {
		setIsToggle(!isToggle);
		setIsOpen(!isOpen);
	};
	const expo = { isToggle, isOpen, togglerHandler };
	return <AppContext.Provider value={expo}>{children}</AppContext.Provider>;
};

// export useContext Object
export const useGlobalContext = () => useContext(AppContext);
